import {
    SpsIcon,
    SpsActionMethod,
    SpsActionDescriptor,
} from "@spscommerce/ds-shared";
import * as React from "react";
import clsx from "clsx";

import * as PropTypes from "../prop-types";
import { SpsCheckbox } from "../form/checkbox/SpsCheckbox";
import { SpsDropdown } from "../dropdown/SpsDropdown";

const propsDoc = {
    checked: "boolean",
    onChange: "ChangeEventHandler",
    indeterminate: "boolean",
    disabled: "boolean",
    options: "Array<SpsActionMethod | [SpsActionDescriptor, () => void]>",
};

const propTypes = {
    ...PropTypes.spsGlobalPropTypes,
    checked: PropTypes.bool,
    onChange: PropTypes.fun<React.ChangeEventHandler>(),
    indeterminate: PropTypes.bool,
    options: PropTypes.arrayOf<SpsActionMethod | [SpsActionDescriptor, () => void]>(
        PropTypes.oneOfType([PropTypes.func, PropTypes.any])
    ).isRequired,
    disabled: PropTypes.bool,
};

export type SpsCheckboxDropdownProps = PropTypes.InferTS<typeof propTypes, HTMLElement>;

export function SpsCheckboxDropdown(props: SpsCheckboxDropdownProps) {
    const {
        options,
        className,
        checked,
        onChange,
        indeterminate,
        disabled,
        ...rest
    } = props;

    const classes = clsx(
        "sps-checkbox-dropdown",
        className,
    );

    return (
        <span className={classes} {...rest}>
            <SpsCheckbox
                indeterminate={indeterminate}
                checked={checked}
                disabled={disabled}
                onChange={onChange as any}
                inline={true}
            />
            <SpsDropdown
                disabled={disabled}
                options={options}
                icon={SpsIcon.CHEVRON_DOWN}
            />
        </span>
    );
}

Object.assign(SpsCheckboxDropdown, {
    props: propsDoc,
    propTypes,
    displayName: "SpsCheckboxDropdown",
});
